<div class="container">
  <ion-button *ngIf="data?.closeButtonCallback()"
    class="close-icon"
    fill="clear"
    shape="round"
    (click)="data?.closeButtonCallback()"
    (keypress)="true"
    slot="icon-only"
  >
    <ion-icon name="close" color="primary"> </ion-icon>
  </ion-button>
  <img [src]="data?.logo" class="logo" alt="Logo"/>

  <p class="title">{{ data?.title }}</p>

  <p class="subtitle">{{ data?.subtitle }}</p>

  <div class="button-container">
    <button class="b-btn s-button" (click)="data?.primaryButtonCallback()">
      {{ data?.primaryButtonText }}
    </button>

    <button class="b-btn p-button" (click)="data?.secondaryButtonCallback()">
      {{ data?.secondaryButtonText }}
    </button>
  </div>
</div>
